        

import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import { 
    Container, 
    DropdownContainer, 
    DropdownButton, 
    DropdownContent 
} from './styled';
import { FiChevronDown } from 'react-icons/fi';

export function Tabs(props) {
    const { children, backgroundColor, color, type, maxVisible = 3 } = props;
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const tabsListRef = useRef(null);

    // Convert children to array for easier manipulation
    const childrenArray = useMemo(() => React.Children.toArray(children), [children]);
    
    // Find if any hidden tab is selected
    const selectedIndex = useMemo(() => {
        return childrenArray.findIndex(child => {
            const className = child.props?.className;
            return className && typeof className === 'string' && className.includes('selected');
        });
    }, [childrenArray]);
    const orderedChildren = useMemo(() => {
        if (selectedIndex < maxVisible || selectedIndex === -1) return childrenArray;
        
        const arr = [...childrenArray];
        const [selectedTab] = arr.splice(selectedIndex, 1);
        arr.splice(1, 0, selectedTab);
        return arr;
    }, [childrenArray, selectedIndex, maxVisible]);

    const visibleTabs = orderedChildren.slice(0, maxVisible);
    const hiddenTabs = orderedChildren.slice(maxVisible);

    const isHiddenTabSelected = useMemo(() => {
        return hiddenTabs.some(child => {
            const className = child.props?.className;
            return className && typeof className === 'string' && className.includes('selected');
        });
    }, [hiddenTabs]);

    useEffect(() => {
        if (tabsListRef.current) {
            const selectedTab = tabsListRef.current.querySelector('.selected');
            if (selectedTab) {
                selectedTab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
            }
        }
    }, [selectedIndex]);

    // Toggle dropdown
    const toggleDropdown = useCallback((e) => {
        e.stopPropagation();
        setIsOpen(prev => !prev);
    }, []);

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <Container backgroundColor={backgroundColor} color={color} type={type}>
            <ul className='ul--' ref={tabsListRef}>
                {visibleTabs}
                
                {hiddenTabs.length > 0 && (
                    <DropdownContainer ref={dropdownRef}>
                        <DropdownButton 
                            onClick={toggleDropdown}
                            className={isHiddenTabSelected ? 'has-selected' : ''}
                            title="Mais opções"
                        >
                            <span className="more-text">Mais</span>
                            <FiChevronDown />
                        </DropdownButton>
                        
                        {isOpen && (
                            <DropdownContent>
                                {hiddenTabs.map((child) => (
                                    <div 
                                        key={child.key} 
                                        onClick={() => setIsOpen(false)}
                                        style={{ display: 'contents' }}
                                    >
                                        {child}
                                    </div>
                                ))}
                            </DropdownContent>
                        )}
                    </DropdownContainer>
                )}
            </ul>
        </Container>
    );
}